import React from 'react';
import { Chip, BottomNav } from './ui';
import { C, BADGES } from '../data/constants';

export default function Badges({ onBadge, onTab, activeTab, player }) {
  const earnedSet = new Set(player?.earnedBadges || []);
  const earnedCount = earnedSet.size;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={{ background: '#fff', padding: '14px 16px', borderBottom: `2px solid ${C.border}`, flexShrink: 0 }}>
        <div style={{ fontSize: 22, fontWeight: 900 }}>Your Titles 🏆</div>
        <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>
          {earnedCount} of {BADGES.length} earned — keep going! 💪
        </div>
      </div>

      <div className="scroll-area" style={{ padding: '14px 16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {BADGES.map((b, i) => {
            const isEarned = earnedSet.has(i);
            return (
              <div
                key={i}
                onClick={() => onBadge(i)}
                style={{
                  background: isEarned ? 'linear-gradient(180deg,#FFFDF0,#fff)' : '#fff',
                  border: `2px solid ${isEarned ? C.goldLight : C.border}`,
                  borderRadius: 16, padding: '14px 10px', textAlign: 'center',
                  cursor: 'pointer', boxShadow: `0 2px 0 ${isEarned ? '#D4A000' : C.border}`,
                  opacity: isEarned ? 1 : 0.5,
                }}
              >
                <div style={{ fontSize: 26, marginBottom: 5 }}>{b.ic}</div>
                <Chip type={isEarned ? 'gr' : 'bl'} style={{ marginBottom: 5 }}>
                  {isEarned ? 'Earned ✅' : 'Locked 🔒'}
                </Chip>
                <div style={{ fontSize: 11, fontWeight: 700, lineHeight: 1.3, marginBottom: 3, marginTop: 4 }}>{b.name}</div>
                <div style={{ fontSize: 9, color: C.muted }}>{b.civ}</div>
                {b.reward && (
                  <div style={{ marginTop: 5 }}>
                    <Chip type="or" style={{ fontSize: 8 }}>🎁 Real reward!</Chip>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ height: 16 }} />
      </div>

      <BottomNav active={activeTab} onTab={onTab} />
    </div>
  );
}
